var AddedMatchesModifier = /** @class */ (function () {
    function AddedMatchesModifier(modelKeyRepository) {
        this._modelKeyRepository = modelKeyRepository;
    }
    AddedMatchesModifier.prototype.modify = function (content) {
        if (content.events === undefined || content.events.add === undefined) {
            return;
        }
        var matches = content.events.add;
        for (var i = 0; i < matches.length; i++) {
            var match = matches[i];
            var key = this._modelKeyRepository.addMatch(match.l, match.id);
            matches[i] = Object.assign({
                timeAndZone: match.taz,
                name: match.n,
                firstTeam: match.ft,
                secondTeam: match.st,
                notice: match.ntc,
                type: match.t,
                realSportId: match.rs,
                outcomesCount: match.oc,
                matchType: match.mt,
                radarId: match.te,
            }, key);
        }
    };
    return AddedMatchesModifier;
}());
export default AddedMatchesModifier;



// WEBPACK FOOTER //
// ./src/repositories/modifier/AddedMatchesModifier.js